import React, { useEffect, useState } from "react";
import { getDelawareDate, url, getLastThreeDigits } from "../env";
import { useNavigate, useLocation } from "react-router";
import { IoArrowBackOutline } from "react-icons/io5";
import icon from "../assets/Icon.png";
import Loader from "../components/loader";
import PopUp3 from "../components/popUp3";
import PopUp from "../components/popUp";

export default function AllTeachers({ }) {
    const location = useLocation();
    const state = location.state;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [allEmploye, setAllEmploye] = useState(null);
    const [attEmployee,setAttEmployee] = useState([]);
       const [attendanceFilterPopUp, setAttendanceFilterPopUp] = useState(false);
        const [selectedStudent, setSelectedStudent] = useState("");
        const [selectedStudentName, setSelectedStudentName] = useState("");
        const [selectedMonth, setSelectedMonth] = useState("");
        const [popupActive, setPopUpActive] = useState({
            active: false,
            type: "error",
            title: "Alert",
            description: "alert"
        })
        const [courseStartDate,setCourseStartDate] = useState("2025-02-01");
    
    
        useEffect(() => {
            if (popupActive.active) {
                const timer = setTimeout(() => {
                    setPopUpActive((prevState) => ({
                        ...prevState,
                        active: false,
                        type: "",
                        title: "",
                        description: ""
                    }));
                }, 4000);
    
                return () => clearTimeout(timer);
            }
        }, [popupActive.active]);
    
    
        const closeAttendanceFilter = () => {
            setAttendanceFilterPopUp(false)
        }
    
    

    const fetchAllEmployees = async (deptName) => {
        setLoading(true);
        try {
            const response = await fetch(`${url}Employee/Get?deptName=${deptName}`);
            const result = await response.json();
            setAllEmploye(result.Employee);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }
    }


    useEffect(() => {
        fetchAllEmployees(location.state.deptName)
    }, []);









    const checkAttendance = async (deptId,deptName, attendanceDate) => {
        setLoading(true);
        try {
            const response = await fetch(
                `${url}employee-attendance/get?deptId=${deptId}&attendanceDate=${attendanceDate}&deptName=${deptName}`
            );
            const result = await response.json();
            setLoading(false);

            if (response.ok && result.attendanceTaken !== undefined) {
                if (result.attendanceTaken === false) {
                    setAttEmployee(result.employees);
                    navigate("/teacher-attendance", {
                        state: {
                            attendanceDate: getDelawareDate(),
                            deptId: deptId,
                            students: result.employees,
                            deptName: deptName
                        },
                    });
                } else {
                    setAttEmployee(result?.data?.attendance);
                    navigate("/teacher-attendance", {
                        state: {
                            attendanceDate: getDelawareDate(),
                            deptId: deptId,
                            students: result?.data?.attendance,
                            deptName: deptName
                        },
                    });
                }
                return result.attendanceTaken;
            } else {
                console.error("Unexpected API response:", result);
                return false;
            }
        } catch (error) {
            console.error("Error fetching attendance data:", error);
            setLoading(false);
            return false;
        }
    };


        // const moveToAttendance = async (courseId, courseName) => {
        //     const isAttendanceTaken = await checkAttendance(courseId, getDelawareDate());
    
        //     if (isAttendanceTaken === false) {
        //         setStudents((prevStudents) => {
        //             const studentsToPass = prevStudents.length > 0 ? prevStudents : [];
        //             navigate("/attendance", {
        //                 state: {
        //                     attendanceDate: getDelawareDate(),
        //                     courseId: courseId,
        //                     students: studentsToPass,
        //                     courseName: courseName
        //                 },
        //             });
        //             return studentsToPass;
        //         });
        //     } else {
        //         setPopUpActive({
        //             active: true,
        //             type: "warning",
        //             title: "Alert",
        //             description: `Attendance already has been taken for ${getDelawareDate()}.`
        //         })
        //     }
        // };

 const fetchTeacherMonthlyReport = async () => {
        setLoading(true);
        try {
            if (selectedMonth!==""&& selectedStudent!=="") {
                const response = await fetch(`${url}employee-attendance/get-attendance?deptId=${location.state.deptId}&empId=${selectedStudent}&month=${selectedMonth}`);
                const result = await response.json();
                if(response.ok){
                    navigate("/teacher", {
                        state: {
                            month: selectedMonth,
                            id: selectedStudent,
                            attendance: result.studentAttendance,
                            totalPresent: result.totalPresents,
                            totalAbsent:result.totalAbsents,
                            name:selectedStudentName,
                            courseName:location.state?.deptName,
                            totalPaidHours:result.totalPaidHours
                        },
                    });
                    setLoading(false);
                    console.log(result,"here is the result");
                }
            }
            
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }
    };








    return (
        <div className="all_teachers">
            <div className="mainAttendanceHeader_1">
                <div className="title">
                    <span className="date">{getDelawareDate()}</span>
                    <span className="courseName">
                        {location.state?.deptName}
                        {/* County */}
                    </span>
                </div>
                <div onClick={() => navigate(-1)} className="back_arrow">
                    <IoArrowBackOutline />
                </div>
                <div className="profile_icon">
                    <img src={icon} alt="" srcset="" />
                </div>

                <div className="btns_set">
                    <div className="btn_1" onClick={() => { checkAttendance(location.state.deptId,location.state.deptName,getDelawareDate()) }}>
                        Attendance
                    </div>

                    <div className="btn_1" onClick={() => { setAttendanceFilterPopUp(true) }}>
                        Monthly Report
                    </div>
                </div>


            </div>

            <div className="studentsTableHeading">
                <span className="studentTableNameHeading">Emp Name</span>
                <span className="studentTableRollHeading">Emp Id</span>
                <span className="studentTableContactHeading">Contact</span>
            </div>
            {allEmploye && allEmploye.map((item) => {
                return (
                    <div className="attendanceTab" key={item._id}>
                        <span className="studentName">{item.empName}</span>
                        <span className="studentRoll">
                            <div className="roll_no">{getLastThreeDigits(item.empId)}</div>
                        </span>
                        <span className={`studentStatus`}>
                            {item.contact ? item.contact : "N/A"}
                        </span>
                    </div>
                );
            })}
             {loading && <Loader />}
                        {popupActive.active && <PopUp type={popupActive.type} title={popupActive.title} description={popupActive.description} />}
                        {attendanceFilterPopUp && (
                            <PopUp3
                                closePopUp={closeAttendanceFilter}
                                studentList={allEmploye.map((student) => ({
                                    label: student.empName,
                                    value: student.empId,
                                }))}
                                startDate={courseStartDate}
                                selectedMonth={selectedMonth}
                                selectedStudent={selectedStudent}
                                setSelectedMonth={setSelectedMonth}
                                setSelectedStudent={setSelectedStudent}
                                setSelectedStudentName={setSelectedStudentName}
                                navigateToReport={fetchTeacherMonthlyReport}
            
                            />
                        )}
        </div>
    )
}